<div class="container-fluid space">
  <form name="form" novalidate>
    <mat-horizontal-stepper>
      <mat-step [stepControl]="firstFormGroup">
        <ng-template matStepLabel>Create project</ng-template>

        <div class="step-container">
          <div class="row">
            <div class="col-6">
              <usimweb-form-input
                class="input"
                placeholder="Project name"
                (selectionChange)="project.name = $event"
                (keyup)="nameValidator($event)"
                [required]="true"
                data-cy="createNewTitle"
              ></usimweb-form-input>
              <mat-error class="error-space" *ngIf="error_name">
                Project name allows alphabets, numbers and symbols( - _ ! $ &#64; . £ € * ? &)
              </mat-error>

              <usimweb-form-input
                class="input"
                placeholder="Description"
                (selectionChange)="project.description = $event"
                (keyup)="descriptionValidator($event)"
                data-cy="createNewDescription"
              ></usimweb-form-input>
              <mat-error class="error-space" *ngIf="error_description">
                Project description allows alphabets, numbers and symbols( - _ ! $ &#64; . £ € * ? &)
              </mat-error>
            </div>
          </div>
        </div>

        <div class="center">
          <button type="button" (click)="create()" mat-stroked-button data-cy="createButton">Create</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </form>
</div>
